import { useApi } from '@/shared/api/http';
import type { RequestParams } from '@/shared/model/types/http';

export const useMorphService = () => {
  const api = useApi();

  const getMorphList = async (params: RequestParams) => {
    return await api.get('morph/', { params });
  };

  const getMorphById = async <T>(type: string, id: number, params: RequestParams) => {
    return await api.get<T>(`morph/${type}/${id}/`, { params });
  };

  return {
    getMorphList,
    getMorphById,
  };
};
